import {StyleSheet} from "aphrodite";

import type {StyleType} from "@khanacademy/wonder-blocks-core";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";

/**
 * Returns the appropriate border styles for a table cell based on its position
 * and whether inline borders are enabled.
 */
export function getCellBorderStyles(
    inlineBorder: boolean | undefined,
    columnIndex: number,
    totalColumns: number,
    rowIndex: number,
    totalRows: number,
): StyleType[] {
    if (!inlineBorder) {
        return [];
    }

    const borderStyles: StyleType[] = [];

    // Add start border for first column
    if (columnIndex === 0) {
        borderStyles.push(styles.inlineBorderStart);
    }

    // Add end border for last column
    if (columnIndex === totalColumns - 1) {
        borderStyles.push(styles.inlineBorderEnd);
    }

    // Add border radius for last row
    if (rowIndex === totalRows - 1) {
        if (columnIndex === 0) {
            borderStyles.push({
                borderEndStartRadius: sizing.size_080,
            });
        }
        if (columnIndex === totalColumns - 1) {
            borderStyles.push({
                borderEndEndRadius: sizing.size_080,
            });
        }
    }

    return borderStyles;
}

export const styles = StyleSheet.create({
    inlineBorderStart: {
        borderInlineStart: `${sizing.size_010} solid ${semanticColor.core.border.neutral.subtle}`,
    },
    inlineBorderEnd: {
        borderInlineEnd: `${sizing.size_010} solid ${semanticColor.core.border.neutral.subtle}`,
    },
    borderTop: {
        borderBlockStart: `${sizing.size_010} solid ${semanticColor.core.border.neutral.subtle}`,
    },
    borderTopStartRadius: {
        borderStartStartRadius: sizing.size_080,
    },
    borderTopEndRadius: {
        borderStartEndRadius: sizing.size_080,
    },
});
